/*!
 * HaiKom JavaScript Library.
 *
 * Copyright (C) HaiKom AB 2007-2014
 */
; (function (window, document, undefined) {
	'use strict';

	if(!window.hk){
		window.hk = {};
	}
	var hk = window.hk;

	var _getBodyAttributes = function () {
		return document.body.attributes;
	};

	var _getBodyAttributeValue = function (name) {
		var result = null;
		var attributes = _getBodyAttributes();
		if(name in attributes) {
			result = attributes[name].value;
		}
		return result;
	};

	if(!hk.getProjectName) {
		hk.getProjectName = function() {
			return _getBodyAttributeValue('data-project-name');
		};
	}

	if(!hk.getPortalId) {
		hk.getPortalId = function() {
			return _getBodyAttributeValue('data-portal-id');
		};
	}

	if(!hk.getCustomerId) {
		hk.getCustomerId = function() {
			return _getBodyAttributeValue('data-customer-id');
		};
	}

	if (typeof window.onSysWebFormsExists !== 'function') {
		window.onSysWebFormsExists = function (callback) {
			if(typeof callback === 'function') {
				_waitForSysWebForms({ 'callback': callback, 'retries': 100, 'timeout': 100 });
			} else if(typeof callback === 'undefined' || callback === null) {
				console.warn('The callback is not defined or null!');
			} else {
				console.warn('The callback is a', typeof callback, 'it should be a function!');
			}
		};

		var _waitForSysWebFormsTimeoutHandler;
		var _waitForSysWebForms = function (options) {
			options = options || {};
			if (isNaN(options.retries) ||
					options.retries < 10) {
				options.retries = 10;
			}
			if (isNaN(options.timeout) ||
					options.timeout < 10) {
				options.timeout = 10;
			}
			if (isNaN(options.retryCount) ||
					options.retryCount < 0) {
				options.retryCount = 0;
			}

			var sysWebFormsExists = typeof Sys === 'object' && typeof Sys.WebForms === 'object';
			if (sysWebFormsExists || options.retryCount >= options.retries) {
				if (_waitForSysWebFormsTimeoutHandler) {
					clearTimeout(_waitForSysWebFormsTimeoutHandler);
				}

				if (sysWebFormsExists) {
					if (typeof options.callback === 'function') {
						options.callback(Sys.WebForms);
					}
				} else {
					console.warn('Sys.WebForms object does not exist after retrying to wait for it ' + options.retries + ' time(s)!');
				}
			} else {
				options.retryCount++;
				_waitForSysWebFormsTimeoutHandler = setTimeout(_waitForSysWebForms, options.timeout, options);
			}
		};
	}

	if (typeof window.toSizeString !== 'function') {
		// Returns a size string of the specified size in bytes with 2 decimals.
		window.toSizeString = function (bytes) {
			return toSizeString(bytes, 2);
		};

		// Returns a size string of the specified size in bytes with the specified number of decimals.
		window.toSizeString = function (bytes, decimals) {
			var result = '0 B';
			if (typeof bytes !== 'undefined') {
				bytes = parseInt(bytes, 10);
				var siPrefices = ['', 'k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'],
					 prefix = 0;
				while (bytes > 1000) {
					bytes /= 1000;
					prefix++;
				}
				result = bytes.toFixed(decimals) + ' ' + siPrefices[prefix] + 'B';
			}
			return result;
		};
	}

	if (typeof window.toPercentString !== 'function') {
		// Returns a percent string with no decimals.
		window.toPercentString = function (percent) {
			return toPercentString(percent, 0);
		};

		// Returns a percent string with the specified number of decimals.
		window.toPercentString = function (percent, decimals) {
			var result = '0%';
			if (typeof percent !== 'undefined') {
				var fPercent = parseFloat(percent);
				if (isFinite(fPercent)) {
					result = Math.min(Math.max(fPercent, '0'), '100').toFixed(decimals) + '%';
				}
			}
			return result;
		};
	}

	if (typeof window.toTimeString !== 'function') {
		// Returns a time string of the format hh:mm:ss representing the specified number of seconds.
		window.toTimeString = function (seconds) {
			var result = null;
			if (typeof seconds !== 'undefined') {
				seconds = parseInt(seconds, 10);
				var hours = parseInt(seconds / 3600, 10);
				if (hours >= 1) {
					seconds -= hours * 3600;
				}
				var minutes = parseInt(seconds / 60, 10);
				if (minutes >= 1) {
					seconds -= minutes * 60;
				}
				result = (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
			}
			return result;
		};
	}

	if (typeof window.callInOpener !== 'function') {
		// Calls a function in the window opener if it exists
		window.callInOpener = function (functionName) {
			if (functionName) {
				var opener = window.opener;
				if (opener &&
					opener[functionName] &&
					typeof opener[functionName] === 'function') {
					opener[functionName]();
				}
			}
		};
	}

	var validationProcessingStatuses = [];
	if (typeof window.disableButtonsOnClick !== 'function') {
		// Disables specified buttons on submit (button ids separated with comma ',') and calls an optional funtion on validation button click and successful validation.
		window.disableButtonsOnClick = function (validationButtons, validationGroup, buttonsToDisable, options) {
			validationButtons = validationButtons || [];
			buttonsToDisable = buttonsToDisable || [];
			var validationControls = [];
			var controlsToDisable = [];

			if (typeof validationButtons === 'string') {
				validationControls = validationButtons.split(',').trim();
			} else if (validationButtons instanceof Array) {
				validationControls = validationButtons;
			}
			for (var i = 0; i < validationControls.length; i++) {
				validationControls[i] = validationControls[i].trim();
				controlsToDisable.push(validationControls[i]);
			}

			if (typeof buttonsToDisable === 'string') {
				buttonsToDisable = buttonsToDisable.split(',').trim();
			}
			for (var j = 0; j < buttonsToDisable.length; j++) {
				controlsToDisable.push(buttonsToDisable[j].trim());
			}

			var validationControlsOptions = typeof options !== 'undefined' ? options : [],
				 validationControlId = null;
			for (var k = 0; k < validationControls.length; k++) {
				validationControlId = validationControls[k].trim();
				validationProcessingStatuses[validationControlId] = false;
				validationControlsOptions.controlsToDisable = controlsToDisable;
				validationControlsOptions.validationGroup = validationGroup;
				$('#' + validationControlId).data('options', validationControlsOptions);
				$('#' + validationControlId).unbind('click', validationButtonClicked).click(validationButtonClicked);
			}
		};
	}

	if (typeof window.validationButtonClicked !== 'function') {
		// Function handling validation button clicks.
		window.validationButtonClicked = function (e) {
			if (validationProcessingStatuses[$(this).attr('id')]) {
				e.preventDefault();
			} else {
				var options = $(this).data('options');
				if (typeof options === 'undefined') {
					options = [];
				}
				if (typeof options.validationbuttonclick === 'function') {
					options.validationbuttonclick(e, $(this));
				}
				var validationGroup = options.validationGroup;
				if (typeof validationGroup !== 'undefined' && (validationGroup === null || clientValidate(validationGroup))) {
					validationProcessingStatuses[$(this).attr('id')] = true;
					if (typeof options.successfulvalidation === 'function') {
						options.successfulvalidation(e, $(this));
					}
					var controls = options.controlsToDisable;
					if (typeof controls !== 'undefined') {
						for (var j = 0; j < controls.length; j++) {
							$('#' + controls[j].trim()).attr('disabled', 'disabled');
						}
					}
				}
			}
		};
	}

	if (typeof window.clientValidate !== 'function') {
		// Performs a client validation with a specified validation group.
		window.clientValidate = function (validationGroup) {
			var result = true;
			if (typeof Page_ClientValidate === 'function') {
				result = Page_ClientValidate(validationGroup);
				Page_BlockSubmit = false;
			}
			return result;
		};
	}

	if (typeof window.getTextBoxCursorPosition !== 'function') {
		window.getTextBoxCursorPosition = function (input) {
			var position = 0;
			if (document.selection) {	// IE Support
				input.focus();
				var selection = document.selection.createRange();
				selection.moveStart('character', -input.value.length);
				position = selection.text.length;
			} else if (input.selectionStart || input.selectionStart === 0) { // Firefox support
				position = input.selectionStart;
			}

			return (position);
		};
	}

	if (typeof window.setTextBoxSelection !== 'function') {
		window.setTextBoxSelection = function (input, selectionStart, selectionEnd) {
			if (input.setSelectionRange) {
				input.focus();
				input.setSelectionRange(selectionStart, selectionEnd);
			} else if (input.createTextRange) {
				var range = input.createTextRange();
				range.collapse(true);
				range.moveEnd('character', selectionEnd);
				range.moveStart('character', selectionStart);
				range.select();
			}
		};
	}
	if (typeof window.setTextBoxCursorPosition !== 'function') {
		window.setTextBoxCursorPosition = function (input, position) {
			setTextBoxSelection(input, position, position);
		};
	}

	if (typeof window.hasTextBoxSelectedText !== 'function') {
		window.hasTextBoxSelectedText = function (input) {
			if (typeof input.selectionStart === 'number') {
				return input.selectionStart !== input.selectionEnd;
			} else if (typeof document.selection !== 'undefined') {
				input.focus();
				return document.selection.createRange().length > 0;
			}
		};
	}

	if (typeof window.generateString !== 'function') {
		window.generateString = function (length, type) {
			var result = [];

			var characters = '';
			if (type.indexOf('#') >= 0) {
				characters += '0123456789';
			}
			if (type.indexOf('A') >= 0) {
				characters += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
			}
			if (type.indexOf('a') >= 0) {
				characters += 'abcdefghijklmnopqrstuvwxyz';
			}
			var characterLength = characters.length;

			if (length > 0 &&
				characterLength > 0) {

				while (length-- > 0) {
					result.push(characters[Math.floor(Math.random() * characterLength)]);
				}
			}

			return result.join('');
		};
	}

	if (typeof window.trimStart !== 'function') {
		window.trimStart = function (character, text) {
			var index = 0;

			while (text[index] === character) {
				index++;
			}

			return text.substr(index);
		};
	}

	if (typeof window.trimEnd !== 'function') {
		window.trimEnd = function (character, text) {
			var index = text.length - 1;

			while (text[index] === character) {
				index--;
			}

			return text.substr(0, index + 1);
		};
	}

})(window, document, undefined);
